import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AboutRight from "./AboutRight";
import VisionMission from "./VisionMission";
import WhyChoose from "./WhyChoose";
import Whatwedo from "./Whatwedo";
import AboutWhy from "./AboutWhy";
import Enquiry from "./Enquiry";
import WhoWeAre from "./WhoWeAre";

const About = () => {
    return (
        <div className="mt-[8%]">
            <AboutRight/>
            <WhoWeAre/>
            <VisionMission/>
            <AboutWhy/>
            <Enquiry/>
        </div>
    );
};

export default About;
